import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pixelazite',
  templateUrl: './pixelazite.component.html',
  styleUrls: ['./pixelazite.component.css']
})
export class PixelaziteComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
